import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateAgendaService, type UpdateAgendaPayload } from '@/services/agendas'
import { AGENDAS_QUERY_KEY } from '@/hooks/agendas/useAgendas'
import { agendaDetailsQueryKey } from '@/hooks/agendas/useAgendaDetails'

export const useUpdateAgenda = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: UpdateAgendaPayload) => updateAgendaService(agendaId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: AGENDAS_QUERY_KEY })
      queryClient.invalidateQueries({ queryKey: agendaDetailsQueryKey(agendaId) })
    },
  })
}
